import type { Pinia } from 'pinia'

export const useSsrQueryCache = () => {
  const { $pinia } = useNuxtApp()
  return useQueryCache($pinia as Pinia)
}
